import { formatDateWithOffset } from 'core/utils/date-utils';
import { TFunction } from 'i18next';
import { VodItem } from './types';

export default (data: VodItem, t: TFunction, offset: number): VodItem => {
  const notWatched = t('vod.column_not_watched')
  return {
    assetId: data ? data.assetId : '',
    transactionId: data ? data.transactionId : '',
    assetTitle: data ? data.assetTitle : '',
    assetType: data ? data.assetType : '',
    purchaseDate: data ? formatDateWithOffset(data.purchaseDate, offset, '') : '',
    expiryDate: data ? formatDateWithOffset(data.endDate, offset, '') : '',
    duration: data ? data.duration : '',
    watched: data
      ? data.lastView === null
        ? notWatched
        : formatDateWithOffset(data.lastView, offset, notWatched)
      : notWatched
  };
};

export const getLabels = (t: TFunction): VodItem => ({
  assetId: t('vod.column_asset_id'),
  transactionId: t('vod.column_transaction_id'),
  assetTitle: t('vod.column_asset_title'),
  assetType: t('vod.column_asset_type'),
  purchaseDate: t('vod.column_purchase_date'),
  expiryDate: t('vod.column_expiry_date'),
  duration: t('vod.column_duration'),
  watched: t('vod.column_watched')
});
